// extracted by mini-css-extract-plugin
module.exports = {"regular":"_93444fe79c--regular--bfuzF","accent":"_93444fe79c--accent--Uj_z2","warn":"_93444fe79c--warn--dGWul"};